<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';

export default {
  name: 'WrapperSpecialist',
  mixins: [unRegisterMixin, storeMixin],
};
</script>
